<template>
  <b-container class="card-container">

    <b-card>
      <b-input-group style='max-width: 350px'>
        <b-form-input placeholder='Search recipient' v-model='query'></b-form-input>
        <b-input-group-append>
          <LoadingButton @click="search" :loading="loading" variant='primary'>Search</LoadingButton>
        </b-input-group-append>
      </b-input-group>
    </b-card>

    <h4>Results</h4>
    <b-card no-body>
      <b-table :items="recipients" :fields="['email']" show-empty empty-text="No results">
        <template v-slot:cell(email)='data'>
          <a target="_blank" :href="`/${data.item.parent.replace('sequence', 'sequences').replace('/recipient', '')}/${data.item.objectID}`">{{data.value}}</a>
        </template>
      </b-table>
    </b-card>

  </b-container>
</template>

<script>

import { db, config } from '@/main.js'

import algoliasearch from 'algoliasearch'

export default {
  metaInfo: {title: 'Search'},
  data() {
    return {
      loading: false,
      query: '',
      index: null,
      recipients: []
    }
  },
  methods: {
    async search() {
      this.recipients = []

      this.loading = true
      let results = await this.index.search(this.query)
      this.loading = false

      for (let hit of results.hits) {
        this.recipients.push(hit)
      }
    }
  },
  created() {
    const client = algoliasearch(config.algolia.client, config.algolia.key);
    this.index = client.initIndex("recipient");
  }
}
</script>

<style scoped>

</style>
